// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>25</span>&nbsp;&nbsp;People go forth to their work&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and to their labour until the evening.<br> </p> </div></div>";
// Exports
module.exports = code;